import React, { useState, useEffect } from 'react';
import ModalTurnos from '../modal/ModalTurnos';
import ModalConfirmacao from '../../modal/ModalConfirmacao';
import EventosService from '../../../service/eventos/EventosService';
import Snackbar from '../../common/Snackbar';
import ResponsiveDatePicker from '../../designacoes/components/ResponsiveDatePicker';

// Custom inline components for counter
const CounterContainer = ({ children }) => (
    <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        border: '1px solid #c5c5c5', 
        borderRadius: '8px', 
        width: '100%', 
        background: '#fdfdfd',
        height: '35px'
    }}>
        {children}
    </div>
);

const CounterButton = ({ onClick, disabled, children }) => (
    <button 
        onClick={onClick}
        disabled={disabled}
        style={{ 
            border: 'none', 
            background: 'none', 
            cursor: disabled ? 'not-allowed' : 'pointer', 
            padding: '0 15px', 
            fontSize: '18px', 
            color: disabled ? '#ccc' : '#888',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}
    >
        {children}
    </button>
);

const CounterValue = ({ value, onChange, onBlur, disabled, readOnly }) => (
    <input
        type={readOnly ? 'text' : 'number'}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        readOnly={readOnly}
        min={1}
        style={{ 
            flex: 1,
            width: 0,
            height: '100%',
            textAlign: 'center', 
            fontSize: '14px',
            fontWeight: 'normal',
            lineHeight: '35px',
            color: '#333',
            border: 'none',
            background: 'transparent',
            outline: 'none',
            padding: 0,
            margin: 0,
            boxSizing: 'border-box',
            MozAppearance: 'textfield',
        }}
    />
);

const chaveTurno = (turno) => [
  turno?.horarioInicial || '',
  turno?.horarioFinal || '',
  Number(turno?.vagas) || 0,
].join('|');

const EVENTO_TITULO_MAXIMO = 100;

const montarMensagemErroEvento = (erroApi, detalhesApi, fallback) => {
  const erro = (erroApi || '').trim();
  const detalhes = (detalhesApi || '').trim();

  if (!erro && !detalhes) {
    return fallback;
  }

  if (!erro) {
    return detalhes;
  }

  if (!detalhes) {
    return erro;
  }

  const detalhesSemPrefixo = detalhes
    .replace(new RegExp(`^${erro.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\s*:?-?\s*`, 'i'), '')
    .trim();

  if (!detalhesSemPrefixo || detalhesSemPrefixo.toLowerCase() === erro.toLowerCase()) {
    return erro;
  }

  return `${erro}\n${detalhesSemPrefixo}`;
};


const CardNovoEvento = ({
  styles,
  eventoEmEdicao,
  handleGravar,
  handleCancelarEdicao,
  eventos = []
}) => {
  const {
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    GravarButton,
    CancelarButton,
    CampoInput,
    CampoTextArea,
    AddButton, 
    CheckboxWrapper
  } = styles;

  const [titulo, setTitulo] = useState('');
  const [data, setData] = useState('');
  const [local, setLocal] = useState('');
  const [complemento, setComplemento] = useState('');
  const [vagas, setVagas] = useState(1);
  const [carrinhos, setCarrinhos] = useState(1);
  const [ilimitado, setIlimitado] = useState(false);
  const [descricao, setDescricao] = useState('');
  const [turnos, setTurnos] = useState([]);
    const [turnoEmEdicao, setTurnoEmEdicao] = useState(null); // Armazena {indice, dados}
    const [imagemName, setImagemName] = useState('');
    const [imagemFile, setImagemFile] = useState(null);
    const fileInputRef = React.useRef();
    const [modalTurnosAberto, setModalTurnosAberto] = useState(false);
    const [snackbar, setSnackbar] = useState({ aberto: false, mensagem: '', tipo: 'success' });
    const [modalDuplicadoAberto, setModalDuplicadoAberto] = useState(false);
    const [payloadPendente, setPayloadPendente] = useState(null); // { payload, logoBase64 }

  const mostrarSnackbar = (mensagem, tipo = 'success') => {
    setSnackbar({ aberto: true, mensagem, tipo });
  };

  const fecharSnackbar = () => {
    setSnackbar({ ...snackbar, aberto: false });
  };

  useEffect(() => {
    if (eventoEmEdicao) {
      setTitulo(eventoEmEdicao.nome || eventoEmEdicao.titulo || '');
      const dateVal = eventoEmEdicao.data ? eventoEmEdicao.data.split('T')[0] : '';
      setData(dateVal);
      ///setLocal(eventoEmEdicao.local || '');
      ///setComplemento(eventoEmEdicao.complemento || '');
      // Separa o nome do link caso venha do banco com a barra |
      const localRaw = eventoEmEdicao.local || '';
      const partesLocal = localRaw.split('|');
      setLocal(partesLocal[0].trim());
      setComplemento(partesLocal.length > 1 ? partesLocal[1].trim() : '');
      const vagsEdit = eventoEmEdicao.vagas || 1;
      const isIlimitado = vagsEdit >= 99999;
      setVagas(vagsEdit);
      setIlimitado(isIlimitado);
      if (!isIlimitado) {
        const carrEdit = eventoEmEdicao.carrinhos || 1;
        const minCarrinhos = Math.max(1, Math.ceil(vagsEdit / 2));
        setCarrinhos(Math.max(carrEdit, minCarrinhos));
      } else {
        setCarrinhos(Math.max(1, eventoEmEdicao.carrinhos || 1));
      }
      setDescricao(eventoEmEdicao.descricao || '');
      // Normalizar turnos do backend (embedded documents)
      const turnosNorm = (eventoEmEdicao.turnos || []).map(t => ({
        _id: t._id,
        horarioInicial: t.horarioInicial || t.de || '',
        horarioFinal: t.horarioFinal || t.ate || '',
        vagas: Number(t.vagas) || 0
      }));
      setTurnos(turnosNorm);
      // Se o evento já tem imagem, mostrar o nome do arquivo
      if (eventoEmEdicao.imagemUrl) {
        setImagemName(eventoEmEdicao.logo?.filename || 'imagem-evento');
      } else {
        setImagemName('');
      }
      setImagemFile(null);
    } else {
      resetForm();
    }
  }, [eventoEmEdicao]);

  const resetForm = () => {
    setTitulo('');
    setData('');
    setLocal('');
    setComplemento('');
    setVagas(1);
    setCarrinhos(1);
    setIlimitado(false);
    setDescricao('');
    setTurnos([]);
    setImagemName('');
    setImagemFile(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

    const onSubmit = async () => {
    // Validar título
    const tituloTrimmed = titulo.trim().replace(/\s+/g, ' ');
    if (!tituloTrimmed) {
      mostrarSnackbar('O título do evento é obrigatório', 'warning');
      return;
    }
    const alphanumCount = (tituloTrimmed.match(/[a-zA-ZÀ-ÿ0-9]/g) || []).length;
    if (alphanumCount < 3) {
      mostrarSnackbar('O título deve conter pelo menos 3 caracteres válidos (letras ou números)', 'warning');
      return;
    }
    const possuiLetra = /[a-zA-ZÀ-ÿ]/.test(tituloTrimmed);
    if (!possuiLetra) {
      mostrarSnackbar('O título do evento não pode conter apenas números ou caracteres especiais', 'warning');
      return;
    }
    if (tituloTrimmed.length > EVENTO_TITULO_MAXIMO) {
      mostrarSnackbar(`O título do evento deve ter no máximo ${EVENTO_TITULO_MAXIMO} caracteres`, 'warning');
      return;
    }

    if (!data) {
      mostrarSnackbar('Selecione a data do evento', 'warning');
      return;
    }
    
    // Validar se a data não é passada
    const dataEvento = new Date(data + 'T00:00:00');
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    dataEvento.setHours(0, 0, 0, 0);
    
    if (dataEvento <= hoje) {
      mostrarSnackbar('Não é possível cadastrar eventos para hoje ou datas passadas. Selecione uma data a partir de amanhã.', 'warning');
      return;
    }

    if (!local) {
      mostrarSnackbar('Informe o local do evento', 'warning');
      return;
    }
    
    if (!turnos || turnos.length === 0) {
      mostrarSnackbar('Adicione pelo menos um turno para o evento', 'warning');
      return;
    }

    // Validar que vagas totais == soma de vagas dos turnos
    if (!ilimitado) {
      const somaVagasTurnos = turnos.reduce((acc, t) => acc + (Number(t.vagas) || 0), 0);
      if (somaVagasTurnos > 0 && vagas !== somaVagasTurnos) {
        mostrarSnackbar(
          `A quantidade de vagas (${vagas}) deve ser igual à soma das vagas dos turnos (${somaVagasTurnos}). Ajuste as vagas do evento ou as vagas por turno.`,
          'warning'
        );
        return;
      }
    }
    
    // Converter imagem para base64 se houver
    let logoBase64 = null;
    if (imagemFile) {
      try {
        logoBase64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            const base64 = reader.result.split(',')[1]; // Remove o prefixo data:image/...;base64,
            resolve({
              data: base64,
              contentType: imagemFile.type,
              filename: imagemFile.name
            });
          };
          reader.onerror = reject;
          reader.readAsDataURL(imagemFile);
        });
      } catch (err) {
        console.error('Erro ao converter imagem:', err);
        mostrarSnackbar('Erro ao processar imagem', 'error');
        return;
      }
    }
    
    // Se o coordenador colou um link, junta com o nome usando o |
    const localFinal = complemento.trim() ? `${local.trim()} | ${complemento.trim()}` : local.trim();

    const payload = {
      nome: tituloTrimmed,
      data,
      local: localFinal,
      descricao,
      vagas: ilimitado ? 99999 : vagas,
      statusInscricao: eventoEmEdicao ? eventoEmEdicao.statusInscricao : 'em_breve',
      // Enviar dados completos dos turnos, não IDs
      turnos: turnos.map(t => ({
        _id: t._id,
        horarioInicial: t.horarioInicial,
        horarioFinal: t.horarioFinal,
        vagas: t.vagas || 0
      })),
      horariosPermitidos: turnos.map(t => `${t.horarioInicial}-${t.horarioFinal}`)
    };
    
    // Só incluir logo no payload se houver nova imagem
    // Se estiver editando e não houver nova imagem, não enviar o campo para preservar a existente
    if (logoBase64) {
      payload.logo = logoBase64;
    }
    
    // Log para debug
    console.log(eventoEmEdicao ? '[ATUALIZAR EVENTO]' : '[CRIAR EVENTO]', 'Payload:', payload);
    console.log('[EVENTO] Token:', localStorage.getItem('accessToken') ? 'Presente' : 'Ausente');
    
    // --- Verificação de duplicado (somente na criação) ---
    if (!eventoEmEdicao) {
      const nomePendente = (payload.nome || '').trim().toLowerCase();
      const dataPendente = payload.data;

      const duplicado = (Array.isArray(eventos) ? eventos : []).find(ev => {
        const nomeEv = (ev.nome || ev.titulo || '').trim().toLowerCase();
        const dataEv = ev.data ? ev.data.split('T')[0] : '';
        return nomeEv === nomePendente && dataEv === dataPendente;
      });

      if (duplicado) {
        setPayloadPendente({ payload, logoBase64 });
        setModalDuplicadoAberto(true);
        return; // Aguarda confirmação do usuário
      }
    }
    // --- Fim verificação de duplicado ---

    await executarGravacao(payload, logoBase64);
  };

  const executarGravacao = async (payload, logoBase64) => {
    // Inclui logo apenas se houver nova imagem
    if (logoBase64 && !payload.logo) {
      payload = { ...payload, logo: logoBase64 };
    }

    try {
      if (eventoEmEdicao) {
        // Modo edição: atualizar evento existente
        await EventosService.updateEvento(eventoEmEdicao._id, payload);
        mostrarSnackbar('Evento atualizado com sucesso!', 'success');
        if (typeof handleGravar === 'function') handleGravar();
        if (typeof handleCancelarEdicao === 'function') handleCancelarEdicao();
      } else {
        // Modo criação: criar novo evento
        const eventoCriado = await EventosService.createEvento(payload);
        mostrarSnackbar('Evento criado com sucesso!', 'success');
        if (typeof handleGravar === 'function') handleGravar(eventoCriado);
        resetForm();
      }
    } catch (err) {
      console.error(eventoEmEdicao ? 'Erro ao atualizar evento:' : 'Erro ao criar evento:', err);
      console.error('Resposta da API:', err.response);
      
      // Verificar se é erro de autenticação
      if (err.response?.status === 401) {
        mostrarSnackbar('Sessão expirada ou inválida. Por favor, faça login novamente.', 'error');
        return;
      }
      
      const serverMsg = montarMensagemErroEvento(
        err?.response?.data?.erro,
        err?.response?.data?.detalhes,
        eventoEmEdicao ? 'Erro ao atualizar evento. Tente novamente.' : 'Erro ao criar evento. Tente novamente.'
      );
      mostrarSnackbar(serverMsg, 'error');
    }
  };

  const confirmarCriacaoComDuplicado = async () => {
    setModalDuplicadoAberto(false);
    if (!payloadPendente) return;
    const { payload, logoBase64 } = payloadPendente;
    setPayloadPendente(null);
    await executarGravacao(payload, logoBase64);
  };

  const cancelarCriacaoComDuplicado = () => {
    setModalDuplicadoAberto(false);
    setPayloadPendente(null);
  };

  const handleTurnos = () => {
        setTurnoEmEdicao(null); // Limpa qualquer edição anterior
        setModalTurnosAberto(true);
  };

    const handleSalvarTurnos = (turnosAtualizados) => {
      // Normalizar os turnos para o formato que a API espera
      const turnosNormalizados = (Array.isArray(turnosAtualizados) ? turnosAtualizados : []).map(t => ({
        _id: t._id,
        horarioInicial: t.de || t.horarioInicial || '',
        horarioFinal: t.ate || t.horarioFinal || '',
        vagas: Number(t.vagas) || 0
      }));

      const turnosExistentes = turnos.filter((_, index) => index !== turnoEmEdicao?.indice);
      const chavesExistentes = new Set(turnosExistentes.map(chaveTurno));
      const duplicadoExistente = turnosNormalizados.find((turno) => chavesExistentes.has(chaveTurno(turno)));

      if (duplicadoExistente) {
        mostrarSnackbar(
          `Já existe um turno cadastrado para ${duplicadoExistente.horarioInicial} - ${duplicadoExistente.horarioFinal} com ${duplicadoExistente.vagas} vaga(s).`,
          'warning'
        );
        return;
      }

      let turnosFinais = [];
        
      if (turnoEmEdicao !== null) {
        // Se estava editando, substitui o turno na posição original
        const novosTurnos = [...turnos];
        // Remove o turno antigo
        novosTurnos.splice(turnoEmEdicao.indice, 1);
        // Adiciona os turnos atualizados na mesma posição
        turnosNormalizados.forEach((turno, i) => {
          novosTurnos.splice(turnoEmEdicao.indice + i, 0, turno);
        });
        turnosFinais = novosTurnos;
        setTurnoEmEdicao(null);
      } else {
        // Se é novo, adiciona ao final
        turnosFinais = [...turnos, ...turnosNormalizados];
      }

      setTurnos(turnosFinais);

      // Ajusta a quantidade total de vagas do evento para ser
      // pelo menos a soma das vagas dos turnos
      const somaVagasTurnos = turnosFinais.reduce((acc, t) => acc + (Number(t.vagas) || 0), 0);
      let novoTotalVagas = vagas;
      if (!ilimitado && somaVagasTurnos > 0 && vagas < somaVagasTurnos) {
        novoTotalVagas = somaVagasTurnos;
        setVagas(somaVagasTurnos);
      }

      // Regra: a cada 2 vagas, 1 carrinho necessário (arredondando para cima, nunca reduzir o que foi definido manualmente)
      if (!ilimitado && novoTotalVagas > 0) {
        const minCarrinhos = Math.max(1, Math.ceil(novoTotalVagas / 2));
        setCarrinhos(prev => Math.max(prev, minCarrinhos));
      }
        
      setModalTurnosAberto(false);
    };

    const handleUpload = () => {
        if (fileInputRef.current) fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files && e.target.files[0];
        if (file) {
            // Validar tipo de arquivo
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            if (!validTypes.includes(file.type)) {
                mostrarSnackbar('Por favor, selecione apenas arquivos JPG, JPEG ou PNG', 'warning');
                return;
            }
            
            // Validar tamanho (1MB = 1048576 bytes)
            if (file.size > 1048576) {
                mostrarSnackbar('A imagem deve ter no máximo 1MB', 'warning');
                return;
            }
            
            setImagemFile(file);
            setImagemName(file.name);
            console.log('Imagem selecionada:', { name: file.name, size: file.size, type: file.type });
        }
    };

  // Common label style for consistent Look
  const labelStyle = { width: '100%', marginBottom: '6px', textAlign: 'left' };
  // Override FormGroup form row to column
  const formGroupColStyle = { flexDirection: 'column', alignItems: 'flex-start', marginBottom: '12px' };

  return (
    <Card>
      <CardHeader>{eventoEmEdicao ? 'Editar Evento' : 'Novo Evento'}</CardHeader>
      <CardBody>
                <ModalTurnos
                    isOpen={modalTurnosAberto}
                    onClose={() => {
                        setModalTurnosAberto(false);
                        // Limpa o estado de edição (não precisa restaurar nada pois não removemos da lista)
                        setTurnoEmEdicao(null);
                    }}
                    turnos={turnoEmEdicao ? [{
                      _id: turnoEmEdicao.dados._id,
                        de: turnoEmEdicao.dados.horarioInicial,
                        ate: turnoEmEdicao.dados.horarioFinal,
                        vagas: turnoEmEdicao.dados.vagas
                    }] : []}
                    onSave={handleSalvarTurnos}
                />
        {/* Titulo */}
        <FormGroup style={formGroupColStyle}>
            <label style={labelStyle}>Título do evento <span style={{fontSize: '11px', color: '#999', fontWeight: 'normal'}}>(obrigatório)</span></label>
            <CampoInput 
                value={titulo} 
            onChange={e => setTitulo(e.target.value.slice(0, EVENTO_TITULO_MAXIMO))} 
            maxLength={EVENTO_TITULO_MAXIMO}
                placeholder="" 
            />
          <span style={{ fontSize: '11px', color: '#666', alignSelf: 'flex-end', marginTop: '4px' }}>
            {titulo.trim().length}/{EVENTO_TITULO_MAXIMO}
          </span>
        </FormGroup>

         {/* Upload Mock */}
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '12px' }}>
                    <input
                        type="file"
                        accept="image/*"
                        style={{ display: 'none' }}
                        ref={fileInputRef}
                        onChange={handleFileChange}
                    />
                    <div style={{ border: '1px dashed #ccc', padding: '10px 15px', borderRadius: '4px', flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '40px', boxSizing: 'border-box' }}>
                        <span style={{ fontSize: '11px', color: '#999' }}>JPG, JPEG, PNG até 1MB</span>
                        <button type="button" onClick={handleUpload} style={{ border: '1px solid #ccc', background: '#fff', padding: '4px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold', color: '#555' }}>Upload</button>
                    </div>
                    {imagemName && (
                        <div style={{ display: 'flex', border: '1px solid #eee', padding: '4px 8px', borderRadius: '4px', alignItems: 'center', gap: '8px', height: '40px', boxSizing: 'border-box' }}>
                            <div style={{ width: '28px', height: '28px', background: '#eee', borderRadius: '50%', flexShrink: 0, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                {imagemFile ? (
                                    <img src={URL.createObjectURL(imagemFile)} alt="preview" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
                                ) : null}
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                <span style={{ fontSize: '11px', fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100px' }}>{imagemName}</span>
                                <span style={{ fontSize: '9px', color: '#999' }}>{imagemFile ? `${Math.round(imagemFile.size/1024)}kb` : ''}</span>
                            </div>
                            <span style={{ cursor: 'pointer', color: '#999', marginLeft: 'auto', padding: '0 4px', fontSize: '14px' }} onClick={() => { 
                                setImagemName(''); 
                                setImagemFile(null); 
                                if (fileInputRef.current) fileInputRef.current.value = '';
                            }}>&times;</span>
                        </div>
                    )}
                </div>

        {/* Data & Turnos */}
        <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
            <div style={{ flex: '0 0 45%', display: 'flex', flexDirection: 'column' }}>
                <label style={{ ...labelStyle, fontSize: '13px', fontWeight: '500', color: '#333' }}>Data</label>
                <ResponsiveDatePicker
                    value={data ? new Date(data + 'T00:00:00') : null}
                    onChange={(date) => {
                        if (date) {
                            const year = date.getFullYear();
                            const month = String(date.getMonth() + 1).padStart(2, '0');
                            const day = String(date.getDate()).padStart(2, '0');
                            setData(`${year}-${month}-${day}`);
                        } else {
                            setData('');
                        }
                    }}
                    minDate={(() => { const amanha = new Date(); amanha.setDate(amanha.getDate() + 1); amanha.setHours(0,0,0,0); return amanha; })()}
                    placeholderText="Selecione a data"
                />
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end', flex: 1 }}>
               <AddButton
                 onClick={handleTurnos}
                 className="btn-turnos"
                 style={{
                   height: '32px',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center',
                   padding: '0 12px',
                   borderRadius: '6px',
                   fontSize: '12px',
                   backgroundColor: '#008080'
                 }}
               >
                 + Turnos
               </AddButton>
            </div>
        </div>

        {/* Lista de turnos adicionados */}
        {turnos && turnos.length > 0 && (
            <div style={{ marginBottom: '12px', padding: '10px', background: '#f0f9ff', border: '1px solid #bae6ff', borderRadius: '6px' }}>
                <div style={{ fontSize: '12px', fontWeight: '600', color: '#0369a1', marginBottom: '8px' }}>
                    Turnos adicionados ({turnos.length}):
                </div>
                {[...turnos].sort((a, b) => {
                    // Ordena pelos horários inicial
                    const horaA = a.horarioInicial || '';
                    const horaB = b.horarioInicial || '';
                    return horaA.localeCompare(horaB);
                }).map((turno, idx) => {
                    // Encontra o índice original do turno não ordenado
                    const indiceOriginal = turnos.findIndex(t => 
                        t.horarioInicial === turno.horarioInicial && 
                        t.horarioFinal === turno.horarioFinal && 
                        t.vagas === turno.vagas
                    );
                    return (
                    <div key={idx} style={{ fontSize: '11px', color: '#0c4a6e', padding: '4px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                            <circle cx="12" cy="12" r="10"/>
                            <polyline points="12 6 12 12 16 14"/>
                          </svg>
                          <span>{turno.horarioInicial} - {turno.horarioFinal}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontWeight: '600' }}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4b2e83" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                            <path d="M9 11a3 3 0 110-6 3 3 0 010 6z" />
                            <path d="M17 11a3 3 0 110-6 3 3 0 010 6z" />
                            <path d="M3 20a6 6 0 0112 0" />
                            <path d="M11 20a6 6 0 0110 0" />
                          </svg>
                          <span>{turno.vagas} vagas</span>
                        </div>
                      </div>
                        <div style={{ display: 'flex', gap: '6px' }}>
                            <svg 
                                width="14" 
                                height="14" 
                                viewBox="0 0 24 24" 
                                fill="none" 
                                xmlns="http://www.w3.org/2000/svg" 
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    // Remover o turno da lista usando o índice original
                                    setTurnos(turnos.filter((_, i) => i !== indiceOriginal));
                                }}
                            >
                                <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2M10 11v6M14 11v6" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            <svg 
                                width="14" 
                                height="14" 
                                viewBox="0 0 24 24" 
                                fill="none" 
                                xmlns="http://www.w3.org/2000/svg" 
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    // Salvar o turno e o índice original para edição
                                    setTurnoEmEdicao({ indice: indiceOriginal, dados: turno });
                                    // Abrir modal (SEM remover o turno da lista)
                                    setModalTurnosAberto(true);
                                }}
                            >
                                <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="#0369a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M18.5 2.50023C18.8978 2.1024 19.4374 1.87891 20 1.87891C20.5626 1.87891 21.1022 2.1024 21.5 2.50023C21.8978 2.89805 22.1213 3.43762 22.1213 4.00023C22.1213 4.56284 21.8978 5.1024 21.5 5.50023L12 15.0002L8 16.0002L9 12.0002L18.5 2.50023Z" stroke="#0369a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </div>
                    );
                })}
            </div>
        )}

        {/* Local & Complemento */}
        <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
             <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <label style={{ ...labelStyle, fontSize: '13px', fontWeight: '500', color: '#333' }}>Local do evento</label>
                <CampoInput value={local} onChange={e => setLocal(e.target.value)} />
            </div>
             
             <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <label style={{ ...labelStyle, fontSize: '13px', fontWeight: '500', color: '#333' }}>Link do Google Maps (Opcional)</label>
                <CampoInput value={complemento} onChange={e => setComplemento(e.target.value)} placeholder="Ex: https://maps.app.goo.gl/..." />
            </div>
        </div>

        {/* Vagas & Carrinhos */}
        <div style={{ display: 'flex', gap: '12px', marginBottom: '4px' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <label style={{ ...labelStyle, fontSize: '13px', fontWeight: '500', color: '#333' }}>Quantidade de vagas</label>
                <CounterContainer style={{ opacity: ilimitado ? 0.5 : 1 }}>
                  <CounterButton disabled={ilimitado} onClick={() => {
                    const somaVagasTurnos = turnos.reduce((acc, t) => acc + (Number(t.vagas) || 0), 0);
                    const minVagas = Math.max(1, somaVagasTurnos);
                    const novoTotal = Math.max(minVagas, vagas - 1);
                    setVagas(novoTotal);
                    if (novoTotal > 0) {
                      const minCarrinhos = Math.max(1, Math.ceil(novoTotal / 2));
                      setCarrinhos(prev => Math.max(prev, minCarrinhos));
                    }
                  }}>-</CounterButton>
                  <CounterValue
                    value={ilimitado ? 'ilimitado' : vagas}
                    readOnly={ilimitado}
                    disabled={ilimitado}
                    onChange={(e) => {
                      const val = parseInt(e.target.value, 10);
                      if (!isNaN(val) && val >= 1) {
                        setVagas(val);
                        const minCarrinhos = Math.max(1, Math.ceil(val / 2));
                        setCarrinhos(prev => Math.max(prev, minCarrinhos));
                      } else if (e.target.value === '') {
                        setVagas('');
                      }
                    }}
                    onBlur={() => {
                      const somaVagasTurnos = turnos.reduce((acc, t) => acc + (Number(t.vagas) || 0), 0);
                      const minVagas = Math.max(1, somaVagasTurnos);
                      const val = Math.max(minVagas, Number(vagas) || 1);
                      setVagas(val);
                      const minCarrinhos = Math.max(1, Math.ceil(val / 2));
                      setCarrinhos(prev => Math.max(prev, minCarrinhos));
                    }}
                  />
                  <CounterButton disabled={ilimitado} onClick={() => {
                    const novoTotal = (Number(vagas) || 1) + 1;
                    setVagas(novoTotal);
                    if (novoTotal > 0) {
                      const minCarrinhos = Math.max(1, Math.ceil(novoTotal / 2));
                      setCarrinhos(prev => Math.max(prev, minCarrinhos));
                    }
                  }}>+</CounterButton>
                </CounterContainer>
            </div>
             <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <label style={{ ...labelStyle, fontSize: '13px', fontWeight: '500', color: '#333' }}>Carrinhos necessários</label>
                <CounterContainer>
                    <CounterButton onClick={() => {
                      const minCarrinhos = Math.max(1, Math.ceil((Number(vagas) || 1) / 2));
                      setCarrinhos(Math.max(minCarrinhos, carrinhos - 1));
                    }}>-</CounterButton>
                    <CounterValue
                      value={carrinhos}
                      onChange={(e) => {
                        const val = parseInt(e.target.value, 10);
                        if (!isNaN(val) && val >= 1) {
                          setCarrinhos(val);
                        } else if (e.target.value === '') {
                          setCarrinhos('');
                        }
                      }}
                      onBlur={() => {
                        const minCarrinhos = Math.max(1, Math.ceil((Number(vagas) || 1) / 2));
                        const val = Math.max(minCarrinhos, Number(carrinhos) || 1);
                        setCarrinhos(val);
                      }}
                    />
                    <CounterButton onClick={() => setCarrinhos((Number(carrinhos) || 1) + 1)}>+</CounterButton>
                </CounterContainer>
            </div>
        </div>

        <CheckboxWrapper>
            <input type="checkbox" checked={ilimitado} onChange={e => {
              setIlimitado(e.target.checked);
              // Ao ativar ilimitado, garante mínimo 1 carrinho
              if (e.target.checked) setCarrinhos(c => Math.max(1, c));
            }} />
            <label>Vagas Ilimitadas</label>
        </CheckboxWrapper>

        <FormGroup style={formGroupColStyle}>
            <label style={labelStyle}>Descrição do evento</label>
            <CampoTextArea rows={4} value={descricao} onChange={e => setDescricao(e.target.value)} style={{ resize: 'none' }} />
        </FormGroup>

        <div
          style={{
            marginTop: 'auto',
            paddingTop: '10px',
            display: 'flex',
            flexDirection: 'row',
            gap: '8px',
            alignItems: 'center'
          }}
        >
          <GravarButton onClick={onSubmit}>
            {eventoEmEdicao ? 'Atualizar' : 'Gravar'}
          </GravarButton>
          {eventoEmEdicao && (
            <CancelarButton
              onClick={() => {
                resetForm();
                if (typeof handleCancelarEdicao === 'function') handleCancelarEdicao();
              }}
            >
              Cancelar
            </CancelarButton>
          )}
        </div>

      </CardBody>
      <ModalConfirmacao
        isOpen={modalDuplicadoAberto}
        onClose={cancelarCriacaoComDuplicado}
        onConfirm={confirmarCriacaoComDuplicado}
        titulo="Evento possivelmente duplicado"
        mensagem={
          payloadPendente
            ? `Já existe um evento com o mesmo nome e data. Deseja criar mesmo assim?`
            : ''
        }
      />
      {snackbar.aberto && (
        <Snackbar 
          mensagem={snackbar.mensagem} 
          tipo={snackbar.tipo} 
          onClose={fecharSnackbar} 
        />
      )}
    </Card>
  );
};

export default CardNovoEvento;
